import React from "react";
import { formatUserFullName } from "./profileNames";
import { DEFAULT_PROFILE_ICON_URL } from "./defaultProfileIcon";
import "./commentAuthorDisplay.css";

/**
 * @param {object} props
 * @param {string} props.email
 * @param {object} [props.authorProfile]
 * @param {string} [props.className]
 * @param {boolean} [props.compact]
 */
export default function CommentAuthorDisplay({ email, authorProfile, className = "", compact = false }) {
  const profile = authorProfile && typeof authorProfile === "object" ? authorProfile : null;
  const label =
    profile?.displayName ||
    formatUserFullName(profile?.firstName, profile?.lastName, email) ||
    email ||
    "";
  const avatarUrl = profile?.avatarUrl || DEFAULT_PROFILE_ICON_URL;
  const styleClass = profile?.usernameStyleClass || "";
  const auraClass = profile?.avatarAuraClass || "";
  const isDefaultAvatar = !profile?.avatarUrl;
  const isPixelCosmetic =
    !isDefaultAvatar && typeof avatarUrl === "string" && avatarUrl.startsWith("data:image/svg");

  const avatarInner = (
    <span
      className={`comment-author-display-avatar${isPixelCosmetic ? " comment-author-display-avatar--pixel" : ""}${
        isDefaultAvatar ? " comment-author-display-avatar--default" : ""
      }`}
    >
      <img src={avatarUrl} alt="" className="comment-author-display-avatar-img" />
    </span>
  );

  return (
    <div className={`comment-author-display${compact ? " comment-author-display--compact" : ""}${className ? ` ${className}` : ""}`}>
      {auraClass ? (
        <span className={`comment-author-display-avatar-shell ${auraClass}`} aria-hidden="true">
          {avatarInner}
        </span>
      ) : (
        <span className="comment-author-display-avatar-shell" aria-hidden="true">
          {avatarInner}
        </span>
      )}
      <span className={`comment-author-display-name${styleClass ? ` ${styleClass}` : ""}`}>{label}</span>
    </div>
  );
}
